<style scoped>
.img-view {
    position: inherit;
    width: 100%;
    height: 100%;
    z-index: 998;
}
.img-view  .img-layer {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.img{
    max-width: 50%;
    max-height: 80%;
    display: block;
    position: fixed;
    left: 0;
    right: 0;
    top: 50px;
    bottom: 0;
    margin: auto;
    z-index: 1000;
}
</style>
<template>
    <div class="img-view" @click="bigImg">
        　　　　 <!-- 遮罩层 -->
        <div class="img-layer"></div>
        <!--图片显示层-->
        <div >
　　　　　　 <img :src="imgSrc" class="img">
        </div>
    </div>
</template>
<script>
    export default {
        props: ['imgSrc'],//接受父组件提供的图片地址
        methods: {
            bigImg() {
                this.$emit('clickit')
            }
        }
    }
</script>
